import React, { useState, useEffect, useCallback, useRef } from "react";
import {
  defaultFilters,
  stateKeys,
  inaugurationKeys,
  formatKeys,
  typologyKeys,
  formatCategory,
  typologyCategory,
  inaugrationCategory,
  stateCategory,
  practiceCategory,
  practiceKeys,
} from "../properties.js";
import "../styles/layouts/filters.scss";
import { log } from "../../src/debug";

export default function Filters({ setFilters }) {
  const [currentData, setCurrentData] = useState(defaultFilters);
  const [expanded, setExpanded] = useState([true, false, false, false]);

  const filterSectionRefs = useRef([]);

  //cheating...
  const lastFilterRef = useRef(null);

  useEffect(() => {
    setFilters(currentData);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const getElements = useCallback((category, keys) => {
    const res = [];
    for (var key in keys) {
      const catDefault =
        defaultFilters[category] && defaultFilters[category].includes(key);
      res.push(
        <label className="filterDetail" key={key} htmlFor={key}>
          <input
            type="checkbox"
            cat={category}
            id={key}
            label={keys[key]}
            defaultChecked={catDefault}
          ></input>
          <span>{keys[key]}</span>
        </label>
      );
    }
    return res;
  }, []);

  const getStateElements = useCallback(() => {
    return (
      <div className="filterBodyInner">
        {getElements(stateCategory, stateKeys)}
      </div>
    );
  }, [getElements]);

  const getInaugurationElements = useCallback(() => {
    return (
      <div className="filterBodyInner">
        {getElements(inaugrationCategory, inaugurationKeys)}
      </div>
    );
  }, [getElements]);

  const getFormatElements = useCallback(() => {
    return (
      <div className="filterBodyInner" ref={lastFilterRef}>
        {getElements(formatCategory, formatKeys)}
      </div>
    );
  }, [getElements]);

  const getTypologyElements = useCallback(() => {
    return (
      <div className="filterBodyInner">
        {getElements(typologyCategory, typologyKeys)}
      </div>
    );
  }, [getElements]);

  const getPracticeElements = useCallback(() => {
    return (
      <div className="filterBodyInner">
        {getElements(practiceCategory, practiceKeys)}
      </div>
    );
  }, [getElements]);

  const setExpandedByIndex = useCallback(
    (index) => {
      const newExp = expanded;
      newExp[index] = !newExp[index];
      setExpanded([...newExp]);

      if (index === 3) {
        setTimeout(() => {
          lastFilterRef.current.scrollIntoView();
        }, 10);
      }
    },
    [expanded]
  );

  const getArrowClass = (idx) => {
    return expanded[idx] ? 'filterSubtitleArrowOpen' : 'filterSubtitleArrowClosed';
  }

  return (
    <div className="filtersContainer">
      <form
        onChange={(e) => {
          const category = e.target.attributes["cat"].value;
          const auxData = { ...currentData };

          if (!auxData[category]) {
            auxData[category] = [];
          }

          if (e.target.checked) {
            auxData[category].push(e.target.id);
          } else {
            auxData[category] = auxData[category].filter(
              (val) => val !== e.target.id
            );
          }

          log(currentData);
          setCurrentData(auxData);
          setFilters(auxData);
        }}
      >
        <div className="filterSection">
          <div className="filterSubtitle">
            <div
              onClick={() => setExpandedByIndex(0)}
              className="filterSubtitleContent"
            >
              <div>Estado</div>
              <div className={getArrowClass(0)}></div>
            </div>
          </div>
          <div
            ref={(el) => (filterSectionRefs.current[0] = el)}
            className={`filterBody ${!expanded[0] ? `filterBodyClosed` : ``}`}
          >
            {getStateElements()}
          </div>
        </div>
        <div className="filterSection">
          <div onClick={() => setExpandedByIndex(1)} className="filterSubtitle">
            <div className="filterSubtitleContent">
              <div>Inauguração</div>
              <div className={getArrowClass(1)}></div>
            </div>
          </div>

          <div
            ref={(el) => (filterSectionRefs.current[1] = el)}
            className={`filterBody ${!expanded[1] ? `filterBodyClosed` : ``}`}
          >
            {getInaugurationElements()}
          </div>
        </div>
        <div className="filterSection">
          <div onClick={() => setExpandedByIndex(2)} className="filterSubtitle">
            <div className="filterSubtitleContent">
              <div>Tipologia</div>
              <div className={getArrowClass(2)}></div>
            </div>
          </div>
          <div
            ref={(el) => (filterSectionRefs.current[2] = el)}
            className={`filterBody ${!expanded[2] ? `filterBodyClosed` : ``}`}
          >
            {getTypologyElements()}
          </div>
        </div>
        <div className="filterSection">
          <div onClick={() => setExpandedByIndex(3)} className="filterSubtitle">
            <div className="filterSubtitleContent">
              <div>Prática</div>
              <div className={getArrowClass(3)}></div>
            </div>
          </div>
          <div
            className={`filterBody ${!expanded[3] ? `filterBodyClosed` : ``}`}
          >
            {getPracticeElements()}
          </div>
        </div>
        <div className="filterSection">
          <div onClick={() => setExpandedByIndex(4)} className="filterSubtitle">
            <div className="filterSubtitleContent">
              <div>Formato</div>
              <div className={getArrowClass(4)}></div>
            </div>
          </div>
          <div
            className={`filterBody ${!expanded[4] ? `filterBodyClosed` : ``}`}
          >
            {getFormatElements()}
          </div>
        </div>
      </form>
    </div>
  );
}
